import type { MotionProps } from 'motion/react';

export const pageMotionProps: MotionProps = {
	initial: {
		marginTop: '20px',
	},
	whileInView: {
		marginTop: '0px',
	},
	exit: {
		marginTop: '20px',
	},
	viewport: {
		once: true,
	},
	transition: {
		duration: 0.35,
	},
};

export const motionProps = {
	initial: {
		opacity: 0.5,
		scale: 0.985,
	},
	whileInView: {
		opacity: 1,
		scale: 1,
	},
	exit: {
		opacity: 0,
		scale: 0.985,
	},
	viewport: {
		once: true,
	},
	transition: {
		duration: 0.35,
	},
} satisfies MotionProps;
export const blockMotionProps = {
	initial: {
		opacity: 0.5,
		scale: 0.985,
		y: '20px',
	},
	whileInView: {
		opacity: 1,
		scale: 1,
		y: '0px',
	},
	exit: {
		opacity: 0,
		scale: 0.985,
		y: '20px',
	},
	viewport: {
		once: true,
	},
	transition: {
		duration: 0.35,
	},
} satisfies MotionProps;
export const elementMotionProps = {
	initial: {
		opacity: 0.2,
		scale: 0.985,
	},
	whileInView: {
		opacity: 1,
		scale: 1,
	},
	exit: {
		opacity: 0,
		scale: 0.985,
	},
	viewport: {
		once: true,
	},
	transition: {
		duration: 0.35,
	},
} satisfies MotionProps;
